// extracted by mini-css-extract-plugin
export default {"container":"common_container__7E6RD","wrapper--content":"common_wrapper--content__V5Mu1"};